/* eslint-disable prefer-arrow-callback */
/* eslint-disable camelcase */
/* eslint-disable no-loop-func */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-undef */
import $ from 'jquery';
import { Get } from './Get';
import { queryApi, getQuerySearch, getQuerySearchBestseller } from './Query';
import { IconBasket } from './Icons';

window.App = {
  vars: {
    ...Config.vars,
    xhr: '',
    ajaxLoad: {},
  },
  txt: {
    ...Config.txt,
  },
  fn: {
    change_url: (url) => {
      if (history.pushState) {
        history.pushState({ foo: 'bar' }, '', decodeURIComponent(url));
      }
    },
    changeUrlNotHistory: (url) => {
      if (history.replaceState) {
        history.replaceState({}, '', decodeURIComponent(url))
      }
    },
    evalJSFromHtml: (html) => {
      const newElement = document.createElement('div');
      newElement.innerHTML = html;
      const result = newElement.getElementsByTagName('script');
      const scripts = [];
      for (let i = 0; i < result.length; ++i) {
        if (
          result[i].tagName === 'SCRIPT' &&
          (result[i].className === 'ajaxLoad' || result[i].parentNode.className === 'ajaxLoad')
        ) {
          scripts.push(result[i]);
        }
      }
      $('body').append(scripts);
    },
    load: (_url, target, callback, paramets) => {
      if (App.vars.xhr && App.vars.xhr.readystate !== 4) {
        App.vars.xhr.abort();
      }
      $(target).addClass('load-content');
      for (let i = 0; target.length > i; i++) {
        $(target[i][0]).addClass('load-content');
      }
      App.vars.xhr = $.ajax({
        url: _url + paramets,
        timeout: 16000,
        success: (data) => {
          for (let i = 0; target.length > i; i++) {
            $(target[i][0]).removeClass('load-content').html($(data).find(target[i][1]).html());
          }
          App.fn.change_url(_url);
          App.fn.evalJSFromHtml(data);
          if (callback) callback();
        },
        error: () => {
          window.location.href = _url;
        },
      });
    },
    variety: (value, single, plural) => (value === 1 ? single : plural),
    setGrid: () => {
      switch (App.vars.view) {
        case 5:
        case 4:
        case 3:
          $('.domHandler').each(function domHandlerEach() {
            const name = $(this).data('item');
            $(this).after($(name));
            $(this).remove();
          });
          break;
        case 2:
        case 1:
        default:
          $('.setMobileGrid').each(function setGridEach() {
            const name = $(this).data('item');
            if (!$(`.domHandler[data-item="${name}"]`).length) {
              $(name).before(`<del class="domHandler d-none" data-item="${name}">`);
              $(this).append($(name));
            }
          });
          break;
      }
    },
    runAjaxFn: () => {
      App.vars.view = $('#viewType').width();
      App.runArr(App.fnrun.all, 'all', true);
      if (!App.vars.view) return false;
      App.runArr(App.fnrun[App.vars.view], App.vars.view, true);
    },
    getRwdSrc: (obj) => {
      let rwdSrc = [obj.data('src_mobile'), obj.data('src_tablet'), obj.data('src_desktop'), obj.data('src_desktop')];
      let src = rwdSrc[App.vars.view - 1];
      if (!src) {
        rwdSrc = rwdSrc.join(' ').split(' ');
        if (rwdSrc.length) {
          if (App.vars.view === 1) {
            // eslint-disable-next-line prefer-destructuring
            src = rwdSrc[0];
          } else {
            src = rwdSrc.pop();
          }
        }
      }
      return src;
    },
    rwdBanner: (name, view) => {
      for (const i in view) {
        App.run(
          () => {
            $(name)
              .find('img.rwd-src')
              .each(function rwdBannerEach() {
                const $this = $(this);
                $this.attr('src', App.fn.getRwdSrc($this));
              });
          },
          view[i],
          name,
        );
      }
    },
    news_data: (data) => {
      const arr = data && data.data ? data.data.split('-') : '';
      if (arr.length < 3) {
        return false;
      }
      const formatted = data.format || '%d-%m-%y';
      if (data.month_names) arr[1] = data.month_names[parseInt(arr[1], 10) - 1];
      return formatted.format(arr[2], arr[1], arr[0]);
    },
    replaceSelects: (elements, name, callbackOnChange, callbackAfterReplace) => {
      elements.each(function replaceSelectEach(i) {
        const $select = $(this);
        const number = i;
        const $selectValue = $select.val();
        const $selectName = $select.attr('name');
        let $labelName = '';
        if ($select.data('label')) {
          $labelName = `<b>${$select.data('label')}</b>`;
        }
        const $ul = $(
          `<div class="f-dropdown f-group ${$select.attr('class')}">
            <ul class="f-dropdown-menu" aria-labelledby="${name}${number}"></ul>
          </div>`,
        );
        $select.children().each(function selectChildrenEach(index) {
          const $option = $(this);
          const $li = $('<li>');
          const dataAttrs = [];
          $.each($option.data(), (key, value) => {
            dataAttrs.push(`data-${key}=${value}`);
          });
          let $data;
          if (dataAttrs.length) {
            $data = dataAttrs.join(' ');
          } else $data = '';
          $(`<a data-index="${index}" ${$data}>`)
            .attr('href', `#${$option.attr('value')}`)
            .attr('data-value', $option.attr('value'))
            .text($option.text())
            .addClass($selectValue === $option.attr('value') ? 'selected' : '')
            .appendTo($li);
          $li.appendTo($ul.find('ul'));
          if ($option.attr('class')) {
            $li.addClass($option.attr('class'));
          }
          if ($option.attr('data-price')) {
            $li.attr('data-price', $option.attr('data-price'));
          }
        });
        $ul
          .prepend(
            `<button
              id="${name}${number}"
              class="f-control f-dropdown-toggle"
              data-indexcurrent="0"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true">
              ${$labelName}
              <span>${$select.find('option:selected').text()}</span>
            </button>`,
          )
          .prepend(
            `<input class="select_hidden searching_ajax" type="hidden" name="${$selectName}" value="${$selectValue}" />`,
          );
        if (callbackOnChange) {
          $ul.find('li').on('click.option', function replaceSelectUlClick() {
            callbackOnChange($(this));
          });
        }
        $select.replaceWith($ul);
        if (callbackAfterReplace) {
          callbackAfterReplace($(this));
        }
      });
    },
    addFocused: function addFocusedClassOnInput(event, selector) {
      const self = selector ? $(selector) : $(this);
      if (self.next().hasClass('control-label') || self.next().hasClass('f-label')) {
        if (self.val() !== '') {
          self.addClass('focused');
        } else {
          self.removeClass('focused');
        }
      }
    },
    dropdownClick: (elem, submit) => {
      const curr = elem.find('a');
      const value = curr.data('value');
      const content = curr.html();
      const ul = elem.parents('.f-dropdown');
      ul.find('input').val(value);
      ul.find('button span').html(content);
      ul.find('.selected').removeClass('selected');
      curr.addClass('selected');
      if (submit) elem.parents('form').submit();
    },
    sesion2link: () => {
      const client = $.cookie('client');
      const name = 'client';
      const regex = new RegExp(`[\\?&]${name}([^&#]*)`);
      if (
        !(client && !$.isEmptyObject(App.vars.sites) && App.vars.session_share && App.vars.session_share === 'true')
      ) {
        return false;
      }
      $('a[href*="http://"],a[href*="https://"],a[href^="//"]').each(function sessionToLinkEach() {
        if ($.inArray(this.hostname, App.vars.sites) !== -1) {
          const link = $(this).get(0);
          const url = link.href;
          const results = regex.exec(url);
          if (results == null) {
            if (url.indexOf('?') !== -1) {
              link.pathname += `&client=${client}`;
            } else {
              link.pathname += `?client=${client}`;
            }
          }
        }
      });
    },
    mobileMenuGen: (reverse = false) => {
      if (reverse) {
        $('.--mobile-label').remove();
      } else if ($('.--mobile-label').length <= 2) {
        const menuList = $('aside .nav-link + .navbar__wrapper');
        $.each(menuList, (index, val) => {
          const navHeader = $(val).prev();
          $(val).prepend(`<div class="--mobile-label">
            <div class="nav-header"></div>
            <button type="button" class="navbar-toggler">
              <div class="hamburger --squeeze">
                <div class="--inner"></div>
              </div>
            </button>
          </div>`);
          $(val).find('.nav-header').prepend(navHeader.clone());
        });
        const menuSubList = $('.nav-link.--has-child');
        menuSubList.each(function menuSubListEach() {
          const subSubMenu = $(this)
            .parents('.navbar__wrapper')
            .find(`.navbar-subsubnav[data-child_id=${$(this).data('child')}]`);
            subSubMenu.prepend(`<li class="--mobile-label">
            <div class="nav-header"></div>
            <button type="button" class="navbar-toggler">
              <div class="hamburger --squeeze">
                <div class="--inner"></div>
              </div>
            </button>
          </li>`);
          subSubMenu.find('.nav-header').prepend($(this).clone());
        });
      }
    },
    categoryDivider: (selector) => {
      const description = selector || '.search_categoriesdescription_sub';
      const children = $(description).children();
      let categorySize = App.vars.categorySize !== undefined ? App.vars.categorySize : 512;

      if (children.length > 1 && !$('.search_categoriesdescription_next').length && categorySize !== 0) {
        $(description).after(
          `<div class="search_categoriesdescription_next cm"><a class="show_description">${
            App.vars.show_description ? App.vars.show_description : 'Czytaj więcej'
          }</a></div>`,
        );
        $.each(children, (indexInArray, valueOfElement) => {
          const amountWithElementLength = (categorySize - valueOfElement.innerText.length) * -1;
          if (categorySize - valueOfElement.innerText.length <= 0 && amountWithElementLength >= categorySize) {
            $(valueOfElement).appendTo('.search_categoriesdescription_next');
          }
          categorySize -= valueOfElement.innerText.length;
        });
      }
      $(description).removeClass('skeleton');
      return false;
    },
    deviceTests: () => {
      const classes = [];
      if ('ontouchstart' in window) classes.push('touch');
      else classes.push('no-touch');

      classes.forEach((newClass) => {
        document.querySelector('body').classList.add(newClass);
      });
    },
    splitFirm: () => {
      const products = document.querySelectorAll('.hotspot .product__name_wrapper');
      products.forEach((product) => {
        const link = product.querySelector('.product__name');
        const name = link.innerHTML;
        if (name.indexOf('OstroVit Pharma') > -1) {
          if (product.querySelector('.product__name_firm'))
            product.querySelector('.product__name_firm').remove();
          const firm = document.createElement('SMALL');
          firm.classList.add('product__name_firm');
          firm.innerHTML = 'OstroVit Pharma';
          product.before(firm);
          link.innerHTML = name.substr(15);
          return;
        }
        if (name.indexOf('OstroVit') > -1) {
          if (product.querySelector('.product__name_firm'))
            product.querySelector('.product__name_firm').remove();
          const firm = document.createElement('SMALL');
          firm.classList.add('product__name_firm');
          firm.innerHTML = 'OstroVit';
          product.before(firm);
          link.innerHTML = name.substr(9);
        }
      });
    },
    splitFirmSearch: () => {
      const products = document.querySelectorAll('.search .product__name');
      products.forEach((product) => {
        const link = product.querySelector('.product__name-link');
        const name = link.innerHTML;
        if (name.indexOf('OstroVit Pharma') > -1) {
          if (product.querySelector('.product__name_firm'))
            product.querySelector('.product__name_firm').remove();
          const firm = document.createElement('SMALL');
          firm.classList.add('product__name_firm');
          firm.innerHTML = 'OstroVit Pharma';
          product.prepend(firm);
          link.innerHTML = name.substr(15);
          return;
        }
        if (name.indexOf('OstroVit') > -1) {
          if (product.querySelector('.product__name_firm'))
            product.querySelector('.product__name_firm').remove();
          const firm = document.createElement('SMALL');
          firm.classList.add('product__name_firm');
          firm.innerHTML = 'OstroVit';
          product.prepend(firm);
          link.innerHTML = name.substr(9);
        }
      });
    },
    splitFirmProjector: () => {
      const product = document.querySelector('.projector__name');
      const name = product.innerHTML;
      if (product.querySelector('.projector__name_firm'))
        product.querySelector('.projector__name_firm').remove();
      if (name.indexOf('OstroVit Pharma') > -1) {
        const firm = document.createElement('SMALL');
        firm.classList.add('projector__name_firm');
        firm.innerHTML = 'OstroVit Pharma ';
        product.innerHTML = name.substr(15);
        product.prepend(firm);
        return;
      }
      if (name.indexOf('OstroVit') > -1) {
        const firm = document.createElement('SMALL');
        firm.classList.add('projector__name_firm');
        firm.innerHTML = 'OstroVit ';
        product.innerHTML = name.substr(9);
        product.prepend(firm);
      }
    },
    getRestrictedProductsId: () => {
      const result = [];
      if (typeof restrictedProducts === 'undefined') return result;
      if (App.vars.countryId || document.getElementById('delivery_region') || document.getElementById('client_region')) {
        const deliveryCountry = (!document.querySelector('.page__client-new') && App.vars.countryId) ? App.vars.countryId : document.getElementById('delivery_region').disabled ? document.getElementById('client_region').value : document.getElementById('delivery_region').value;
        const basketProducts = [];
        document.querySelectorAll(`.basket__block[data-product-id]`).forEach((product) => {
          basketProducts.push(product.dataset.productId);
        })
        basketProducts.forEach((product) => {
          restrictedProducts.forEach((country) => {
            if (country.id == deliveryCountry) {
              country.products.forEach((element) => {
                if (product == element) result.push(product);
              })
            }
          })
        })
        
      }
      return result;
    },
    getRestrictedProducts: () => {
      const result = [];
      if (typeof restrictedProducts === 'undefined') return result;
      if (App.vars.countryId || document.getElementById('delivery_region') || document.getElementById('client_region')) {
        const deliveryCountry = (!document.querySelector('.page__client-new') && App.vars.countryId) ? App.vars.countryId : document.getElementById('delivery_region').disabled ? document.getElementById('client_region').value : document.getElementById('delivery_region').value;
        if (document.querySelector('.basket__block[data-product-id]') && !App.vars.Basket.products) {
          const basketProducts = [];
          document.querySelectorAll(`.basket__block[data-product-id]`).forEach((product) => {
            basketProducts.push(product.dataset.productId);
          })
          basketProducts.forEach((product) => {
            restrictedProducts.forEach((country) => {
              if (country.id == deliveryCountry) {
                country.products.forEach((element) => {
                  if (product == element) result.push(product);
                })
              }
            })
          })
        } else if (App.vars.Basket) {
          if (App.vars.Basket.products) {
            App.vars.Basket.products.forEach((product) => {
              restrictedProducts.forEach((country) => {
                if (country.id == deliveryCountry) {
                  country.products.forEach((element) => {
                    if (product.id == element) result.push(product);
                  })
                }
              })
            });
          }
        } else if (App.vars.basketProducts) {
          App.vars.basketProducts.forEach((product) => {
            restrictedProducts.forEach((country) => {
              if (country.id == deliveryCountry) {
                country.products.forEach((element) => {
                  if (product.id == element) result.push(product);
                })
              }
            })
          });
        }
      }
      return result;
    },
    createRestrictedPopup: (restrictedBasket) => {
      if (document.querySelector('.popup.--restricted')) {
        document.querySelector('.popup.--restricted').remove();
      }
      const popup = document.createElement('DIV');
      popup.classList.add('popup');
      popup.classList.add('--restricted');

      const existingId = [];
      document.querySelectorAll(`.basket__block[data-product-id]`).forEach((product) => {
        existingId.push(parseInt(product.dataset.productId));
      })

      let html = '';

      html = `
        <div class="popup__content">
          <div class="popup__header">${App.txt.restricted.popupDescription}</div>
          <div class="popup__products">
      `;
      
      restrictedBasket.forEach((product) => {
        if (document.querySelectorAll(`.basket__block[data-product-id]`).length) {
          if (existingId.includes((parseInt(product.id)))) {
            html += `
              <div class="popup__product d-flex align-items-center">
                <a href="${product.link}"><img src="${product.icon}" /></a>
                <div class="popup__product_info d-flex flex-column">
                  <a href="${product.link}">${product.name}</a>
                  <span>${App.txt.restricted.productCode} ${product.id}</span>
                </div>
              </div>
            `;
          }
        } else {
          html += `
            <div class="popup__product d-flex align-items-center">
              <a href="${product.link}"><img src="${product.icon}" /></a>
              <div class="popup__product_info d-flex flex-column">
                <a href="${product.link}">${product.name}</a>
                <span>${App.txt.restricted.productCode} ${product.id}</span>
              </div>
            </div>
          `;
        }
      });

      const proceedHref = document.getElementById('basket_go_next') ? '/order1.php' : '#proceed';

      html += `
          </div>
          <div class="popup__buttons d-flex flex-column flex-md-row justify-content-end">
            <a href="/basketedit.php" class="btn --small --outline --back_basket">${App.txt.restricted.popupBackButton}</a>
            <a href="${proceedHref}" class="btn --small --solid --proceed">${App.txt.restricted.popupRemoveButton}</a>
          </div>
        </div>
        <div class="popup__background"></div>
      `;

      popup.innerHTML = html;
      document.querySelector('body').append(popup);

      const proceedButton = popup.querySelector('.btn.--proceed');
      if (proceedButton) {
        proceedButton.addEventListener('click', (e) => {
          e.preventDefault();
          let json = '{';
          restrictedBasket.forEach((product, index) => {
            json += `"product[${index}]":${product.id},"size[${index}]":"${product.size}","additional[${index}]":"${product.md5_additional}","set_quantity[${index}]":0${restrictedBasket.length -1 === index ? '' : ','}`;
          });
          json += '}';

          const parsedJson = JSON.parse(json);
          const data = new FormData();
          for (let key in parsedJson) data.append(key, parsedJson[key]);

          fetch('/basketchange.php?type=multiproduct', {
            method: 'POST',
            body: data,
          })
            .then(() => {
              if (document.getElementById('basket_go_next')) window.location.href = document.getElementById('basket_go_next').href;
              else if (document.getElementById('client_new_form')) document.getElementById('client_new_form').submit();
              else window.location.href = document.getElementById('basket_go_next').href;
            }).catch((error) => {
              console.error(error);
              window.location.href = '/return.php?status=orderedit_dataerror';
            });
        });
      }

      const background = popup.querySelector('.popup__background');
      if (background) {
        background.addEventListener('click', (e) => {
          e.preventDefault();
          document.querySelector('.popup.--restricted').remove();
        })
      }

      if (!document.getElementById('basket_go_next')) {
        const sendData = async () => {
          const formData = new FormData(document.getElementById('client_new_form'));
          popup.classList.add('load-content');
          try {
            await fetch("/client-new.php?operation=onceorder", {
              method: "POST",
              // Set the FormData instance as the request body
              body: formData,
            })
            .then(() => {
              popup.classList.remove('load-content');
              window.location.href = '/basketedit.php';
            });
          } catch (e) {
            console.error(e);
            popup.classList.remove('load-content');
            window.location.href = '/return.php?status=orderedit_dataerror';
          }
        }
        const backButton = popup.querySelector('.btn.--back_basket');
        if (backButton) {
          backButton.addEventListener('click', (e) => {
            e.preventDefault();
            sendData();
          })
        }
      }
    },
  },
  fnrun: {},
  files: [],
  run: (fun, mode, wrapper, ajax) => {
    if ($.isArray(mode)) {
      let i;
      for (i in mode) {
        if (!App.fnrun[mode[i]]) App.fnrun[mode[i]] = [];
        App.fnrun[mode[i]].push({ w: wrapper, fn: fun, a: ajax });
      }
    } else {
      if (!App.fnrun[mode]) App.fnrun[mode] = [];
      App.fnrun[mode].push({ w: wrapper, fn: fun, a: ajax });
    }
  },
  runArr: (arr, mode, ajax) => {
    if (arr) {
      let i;
      let z = 0;
      for (i = 0, z = arr.length; i < z; i++) {
        const { w, fn, a } = arr[i];
        if (ajax) {
          if (w) {
            if ($(w).length && a) {
              fn();
            }
          } else {
            if (a) {
              fn();
            }
          }
        } else {
          if (w) {
            if ($(w).length) {
              fn();
            }
          } else {
            fn();
          }
        }
      }
    }
  },
  runApp: () => {
    App.fn.deviceTests();
    App.vars.view = $('#viewType').width();
    let tmpView = App.vars.view;
    App.runArr(App.fnrun.all, 'all');
    if (!App.vars.view) return false;
    App.runArr(App.fnrun[App.vars.view], App.vars.view);
    App.fn.setGrid();
    $(window).off('resize.view');
    $(window).on('resize.view', () => {
      App.vars.view = $('#viewType').width();
      if (App.vars.view !== tmpView) {
        tmpView = App.vars.view;
        App.runArr(App.fnrun[App.vars.view], App.vars.view);
        App.fn.setGrid();
      }
    });
    Get.init();
    // iaiGet.init();
  },
};

export default App;

export const getSectionLabelByKey = (label) => {
  const { products, series, categories, producers, cms } = Literals.searchList;
  switch (label) {
    case 'products':
      return products;
    case 'series':
      return series;
    case 'menuNodes':
      return categories;
    case 'producers':
      return producers;
    case 'cms':
      return cms;
    default:
      return '';
  }
};

export const renderProductList = (productArray) => productArray.map(({
  id,
  name,
  iconSmall,
  link,
  price,
  sizes,
  group,
  versionName,
  awardedParameters,
  category
}) => {
  let [productMark, ...productName] = name.split(' ')
  const isSizes = !!sizes;
  const tasteId = 19; //Parametr smaku
  const foodId = 1214554735; //ID kategorii Ukryty Smak w Podpowiedziach

  if (productName[0] == 'Pharma') {
    productMark += ' ' + productName.shift();
  }

  let value;
  let groupValue;
  let isTaste = false;

  if (awardedParameters.length) {
    awardedParameters.forEach((parameter) => {
      if (parameter.id === tasteId) {
        value = parameter.values[0].name;
        groupValue = parameter.name;
        isTaste = true;
      }
    })
  }

  if (!value) value = versionName;
  if (!groupValue) groupValue = group.name;

  return `
  <li class="cartlist__product d-flex align-items-center">
    <a class="icon" href="${link.split('?')[0]}">
      <img loading="lazy" src="${iconSmall}" />
    </a>
    <div class="cartlist__details ${!isSizes ? '--disabled' : ''}">
      <a class="markname" href="${link.split('?')[0]}">
        <span class="mark">${productMark}</span>
        <span class="name">
          <span>${productName.join(' ').split()}</span>
          ${isTaste && productName.join(' ').toLowerCase().indexOf(value.toLowerCase().trimStart()) < 0 && category.id != foodId ? `<span>${groupValue}: ${value}</span>`: ''}
        </span>
      </a>
      <div class="prices">
        <strong class="price">${price.price.gross.formatted}</strong>
      </div>
      ${isSizes ? `<span class="product__actions">
          <button type="button" class="btn --solid --cart" data-product="${id}">
            ${IconBasket} ${window.Literals.projector.addToBasket}
          </button>
        </span>` : `<span class="availability">${window.Literals.projector.statusDisableShort}</span>`}
    </div>
  </li>
`}).join('');

export const renderListSection = (label, list) => `
<div class="searchResult__section">
  <div class="searchResult__label">${getSectionLabelByKey(label)}</div>
  <ul class="searchResult__list">
    ${
      label === 'products'
        ? renderProductList(list)
        : list
            .map(
              (element) => `<li class="searchResult__item --link"><a href="${element.link}">${element.name}</a></li>`,
            )
            .join('')
    }
  </ul>
</div>
`;

export const getSearchByText = async (text) => {
  const res = await $.get(`/search.php?xmlType=typeahead&getProductXML=true&json=true&text=${text}&limit=6`);
  return res;
};

export const renderSearchList = async (value, selector) => {
  $(selector).addClass('--loading');

  if (value === '') {
    const { data } = await queryApi(getQuerySearchBestseller());

    $(selector).html(
      data.products.products
        ? renderListSection('products', data.products.products)
        : `<div class="d-flex align-items-center justify-content-center p-2" style="height: 100%; font-size: 1.2rem;">${Literals.searchList.nothingToShow}</div>`,
    );
  } else {
    const { data } = await queryApi(getQuerySearch(value));

    $(selector).html(
      data.products.products
        ? renderListSection('products', data.products.products)
        : `<div class="d-flex align-items-center justify-content-center p-2" style="height: 100%; font-size: 1.2rem;">${Literals.searchList.nothingToShow}</div>`,
    );
  }
  
  $(selector).removeClass('--loading');
  $('.menu__search, #menu_categories').addClass('--loaded');
}

export const ifDropdownBasketEmpty = () => {
  $('#basket__product-list .loader').removeClass('--empty'); //pokaż loader
  const basketProductList = document.getElementById('basket__product-list');
  if (basketProductList) {
    //ukryj przedmioty i elementy z nimi związane i pokaż treść pustego koszyka
    Array.from(basketProductList.children).forEach((e) => {
      if (!e.classList.contains('loader')) {
        e.classList.toggle('--empty');
      }
    });
  }
  $('.menu__link.--basket').addClass('--empty'); //ukryj kropkę zawartości koszyka
  $('.loader').addClass('--empty'); //ukryj loader
};

//wypełnianie koszyka treścią
export const fillBasket = (basketData) => {
  let newBasketData = {};
  let firstLoad = false;

  if (basketData.response) {
    //zawatość z geta po załadowaniu strony
    newBasketData = basketData.response.basket;
    firstLoad = true;
  } else {
    //zawartość po dodaniu do koszyka (co innego się zwraca)
    newBasketData = basketData;
  }
  console.warn(newBasketData);
  if (newBasketData.products.length) {
    $('.menu__link.--basket').removeClass('--empty');
    if (!document.getElementById('basket__mid')) {
      $('.loader').removeClass('--empty');
    }
    //sprawdzenie czy koszyk był pusty czy nie
    let wasEmpty = true;
    if ($('.basket__empty').hasClass('--empty')) {
      wasEmpty = false;
    } else {
      $('.basket__empty').addClass('--empty');
    }

    const { products } = newBasketData;

    let product = ``;
    products.forEach((prod) => {
      const { id, link, icon, name, product_version_name, versions_name, count, worth_unit, prices } = prod;

      product += `<div data-product-id="${id}"  class="basket__block">
                        <div class="basket__item --photo">
                          <a class="photo__link" href="${link}">
                            <img src="${icon}" alt="${name}">
                          </a>
                        </div>
                        <div class="basket__item --name">
                          <div class="basket__name">
                            <div class="basket__product">
                                <a class="product__link" href="${link}">
                                    <h3 class="product__name">${name}</h3>
                                </a>
                            </div>
                          </div>
                          ${
                            product_version_name.length
                              ? `<div class="basket__param --version">
                              ${versions_name.length ? `<span class="param__label mr-1">${versions_name.indexOf(' \\ ') > -1 ? versions_name.split(' \\ ')[0] : versions_name}:</span>` : ``}
                              ${
                                product_version_name.length
                                  ? `<span class="param__value">${product_version_name.indexOf(' \\ ') > -1 ? product_version_name.split(' \\ ')[0] : product_version_name}</span>`
                                  : ``
                              }
                            </div>`
                              : ``
                          }
                          <div class="basket__price">
                              <span class="basket__sum">${prices.points_worth ? `${prices.points_worth} ${App.txt.pts}` : prices.worth_gros_formatted}</span>
                          </div>
                        </div>
                        <div class="basket__item --quantity">
                          <span class="basket__quantity">${count} ${worth_unit}</span>
                        </div>
                    </div>`;
    });

    /* BASKET REMOVE BUTTON - for future possible uses
    <div class="basket__item --actions">
      <div class="basket__action --remove">
        <button type="button" class="btn --solid --cart --delete" data-product="${id}">
          <span class="remove__button --desktop --rounded d-none d-md-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="15.833" height="20" viewBox="0 0 15.833 20">
              <g transform="translate(0.003 0.001)">
                <path d="M222.856,154.7a.463.463,0,0,0-.458.468v8.852a.458.458,0,1,0,.915,0v-8.852A.463.463,0,0,0,222.856,154.7Zm0,0" transform="translate(-212.249 -147.458)"/>
                <path d="M104.856,154.7a.463.463,0,0,0-.458.468v8.852a.458.458,0,1,0,.915,0v-8.852A.463.463,0,0,0,104.856,154.7Zm0,0" transform="translate(-99.636 -147.458)"/>
                <path d="M1.293,5.953v11.54a2.622,2.622,0,0,0,.67,1.782A2.222,2.222,0,0,0,3.594,20h8.638a2.221,2.221,0,0,0,1.631-.724,2.622,2.622,0,0,0,.67-1.782V5.953a1.789,1.789,0,0,0,1.282-1.961,1.76,1.76,0,0,0-1.729-1.558H11.748V1.849A1.865,1.865,0,0,0,11.222.536,1.771,1.771,0,0,0,9.94,0H5.886A1.771,1.771,0,0,0,4.605.536a1.865,1.865,0,0,0-.527,1.313v.585H1.741A1.76,1.76,0,0,0,.011,3.992,1.789,1.789,0,0,0,1.293,5.953ZM12.232,19.062H3.594a1.469,1.469,0,0,1-1.388-1.569V5.994H13.62v11.5a1.469,1.469,0,0,1-1.388,1.569ZM4.991,1.849A.914.914,0,0,1,5.251,1.2.868.868,0,0,1,5.886.935H9.94a.868.868,0,0,1,.636.263.914.914,0,0,1,.259.651v.585H4.991ZM1.741,3.371H14.086a.843.843,0,0,1,0,1.686H1.741a.843.843,0,0,1,0-1.686Zm0,0" transform="translate(0 0)"/>
                <path d="M163.856,154.7a.463.463,0,0,0-.458.468v8.852a.458.458,0,1,0,.915,0v-8.852A.463.463,0,0,0,163.856,154.7Zm0,0" transform="translate(-155.942 -147.458)"/>
              </g>
            </svg>
          </span>
        </button>
      </div>
    </div>
   */

    //zmienione tworzenie zawartość ze względu na różne dane zwracane z geta i basketchange
    let price = newBasketData.worth;
    const shippingLimitFree = +newBasketData.shippingLimitFree;
    let shippingCost = +newBasketData.shippingCost;
    let totalCosts = (price + shippingCost).toFixed(2);
    totalCosts = totalCosts.replace('.', ',');
    shippingCost = shippingCost.toFixed(2);
    shippingCost = shippingCost.replace('.', ',');

    const midBasket = document.createElement('div');
    midBasket.classList.add('basket__mid');
    midBasket.classList.add('--empty');
    midBasket.setAttribute('id', 'basket__mid');
    midBasket.innerHTML = product;
    const hasProducts = document.getElementById('basket__mid');

    //przy wczytaniu strony po prostu dodaj treść, przy dodawaniu do koszyka usuń poprzednią treść żeby nie było duplikatów
    if (!firstLoad) {
      if (hasProducts) {
        hasProducts.remove();
      }
    }

    const basketUpper = document.getElementById('basket__upper');
    basketUpper.parentNode.insertBefore(midBasket, basketUpper.nextElementSibling);

    document.getElementById('shippingCost').innerText =
      shippingLimitFree && !shippingCost
        ? price >= shippingLimitFree
          ? window.Literals.dropdownCart.gratis
          : shippingCost + ' ' + newBasketData.currency_sign
        : shippingCost + ' ' + newBasketData.currency_sign;
    price = price.toFixed(2);
    price = price.replace('.', ',');
    document.getElementById('worth').innerText = price + ' ' + newBasketData.currency_sign;
    document.getElementById('totalCost').innerText = totalCosts + ' ' + newBasketData.currency_sign;

    /** ukryj, pokaż odpowiednie elementy, zależnie od tego czy już coś było w koszyku lub czy koszyk był pusty
     * np. jeśli był pusty to najpierw pokaż loader, jak wczyta treść to ją pokaż i ukryj loader, jeśli treść już była w koszyku
     * to loader już nie jest potrzebny itd.
     */
    Array.from(document.getElementById('basket__product-list').children).forEach((e) => {
      if (firstLoad) {
        if (!e.classList.contains('basket__empty')) {
          e.classList.toggle('--empty');
        }
      } else {
        if (!e.classList.contains('basket__empty') && !e.classList.contains('loader') && wasEmpty) {
          e.classList.toggle('--empty');
        }
        if (!wasEmpty && e.classList.contains('basket__mid')) {
          e.classList.toggle('--empty');
        }
      }
    });
    if (!$('.loader').hasClass('--empty')) {
      $('.loader').addClass('--empty');
    }
  }
};
